import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KSerializerClass;
function KSerializer() {
  if (KSerializerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'KSerializer', VOID, VOID, [SerializationStrategy(), DeserializationStrategy()]);
    KSerializerClass = $;
  }
  return KSerializerClass;
}
var DeserializationStrategyClass;
function DeserializationStrategy() {
  if (DeserializationStrategyClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DeserializationStrategy');
    DeserializationStrategyClass = $;
  }
  return DeserializationStrategyClass;
}
var SerializationStrategyClass;
function SerializationStrategy() {
  if (SerializationStrategyClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SerializationStrategy');
    SerializationStrategyClass = $;
  }
  return SerializationStrategyClass;
}
//region block: exports
export {
  DeserializationStrategy as DeserializationStrategy1z3z5pj9f7zc8,
  KSerializer as KSerializerzf77vz1967fq,
  SerializationStrategy as SerializationStrategyh6ouydnm6hci,
};
//endregion

//# sourceMappingURL=KSerializer.mjs.map
